import { ZustandCasinoSearchStore } from './types';

export const getCasinoSearchValueSelector = (state: ZustandCasinoSearchStore) =>
  state.search;

// ================================ ACTIONS ================================

export const setCasinoSearchValueAction = (state: ZustandCasinoSearchStore) =>
  state.setSearch;
